import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import BackToTop from "./common/BackToTop";
import { Styles } from "./styles/footerTwo.js";
import { BLOGS_ENDPOINT } from "../config/api";
import useSiteContent from "../hooks/useSiteContent";

function FooterTwo() {
  const [latestBlogs, setLatestBlogs] = useState([]);
  const footer = useSiteContent("footer");

  useEffect(() => {
    const controller = new AbortController();

    const fetchLatestBlogs = async () => {
      try {
        const response = await fetch(`${BLOGS_ENDPOINT}?limit=10`, {
          signal: controller.signal,
        });
        const payload = await response.json();
        const blogs = Array.isArray(payload.blogs) ? payload.blogs : [];

        const published = blogs
          .filter((b) => b.status === "published")
          .sort(
            (a, b) =>
              new Date(b.publishedAt).getTime() -
              new Date(a.publishedAt).getTime()
          )
          .slice(0, 3);

        setLatestBlogs(published);
      } catch (err) {
        console.error("Footer blogs fetch error:", err);
        setLatestBlogs([]);
      }
    };
    fetchLatestBlogs();
    return () => controller.abort();
  }, []);

  useEffect(() => {
    const form = document.getElementById("form4");
    const email = document.getElementById("email4");

    form.addEventListener("submit", formSubmit);

    function formSubmit(e) {
      e.preventDefault();

      const emailValue = email.value.trim();

      if (emailValue === "") {
        setError(email, "Email can't be blank");
      } else if (!isEmail(emailValue)) {
        setError(email, "Not a valid email");
      } else {
        setSuccess(email);
      }
    }

    function setError(input, message) {
      const formControl = input.parentElement;
      const errorMsg = formControl.querySelector(".input-msg4");
      formControl.className = "form-control error";
      errorMsg.innerText = message;
    }

    function setSuccess(input) {
      const formControl = input.parentElement;
      formControl.className = "form-control success";
    }

    function isEmail(email) {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
    }

    return () => form.removeEventListener("submit", formSubmit);
  }, []);

  return (
    <Styles>
      {/* Footer Two */}
      <footer
        className="footer2"
        style={{
          backgroundImage: footer.backgroundImage
            ? `url(${process.env.PUBLIC_URL}/assets/images/${footer.backgroundImage})`
            : undefined,
        }}
      >
        <Container>
          <Row>
            <Col md="3">
              <div className="footer-logo-info">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/logo/logo2.png"}
                  alt="Swiss School"
                  className="img-fluid"
                />
                <p>{footer.description}</p>
                <ul className="list-unstyled">
                  <li>
                    <i className="las la-map-marker"></i>
                    {footer.address}
                  </li>
                  <li>
                    <i className="las la-envelope"></i>
                    {footer.email}
                  </li>
                  <li>
                    <i className="las la-phone"></i>
                    {footer.phone}
                  </li>
                </ul>
              </div>
            </Col>
            <Col md="3">
              <div className="f-links">
                <h5>{footer.quickLinksTitle}</h5>
                <ul className="list-unstyled">
                  {(footer.quickLinks || []).map((link) => (
                    <li key={link.url}>
                      <Link to={process.env.PUBLIC_URL + link.url}>
                        <i className="las la-angle-right"></i>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col md="3">
              <div className="f-post">
                <h5>{footer.latestUpdatesTitle}</h5>
                {latestBlogs.length > 0 ? (
                  latestBlogs.map((blog) => {
                    const date = blog.publishedAt
                      ? new Date(blog.publishedAt).toLocaleDateString()
                      : "";
                    const slugPath = `/blog-details${
                      blog.slug ? `?slug=${encodeURIComponent(blog.slug)}` : ""
                    }`;
                    return (
                      <div className="post-box d-flex" key={blog._id}>
                        <div className="po-icon">
                          <i className="fab fa-twitter"></i>
                        </div>
                        <div className="po-content">
                          <Link to={process.env.PUBLIC_URL + slugPath}>
                            {blog.title}
                          </Link>
                          <span>{date}</span>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p>No recent posts available.</p>
                )}
              </div>
            </Col>

            <Col md="3">
              <div className="f-newsletter">
                <h5>{footer.newsletterTitle}</h5>
                <p>{footer.newsletterText}</p>

                <form id="form4" className="form">
                  <p className="form-control">
                    <input
                      type="email"
                      placeholder="Enter email here"
                      id="email4"
                    />
                    <span className="input-msg4"></span>
                  </p>
                  <button>Submit</button>
                </form>
              </div>
            </Col>
            <Col md="12">
              <div className="copytext-area text-center">
                <p>
                  Copyright &copy; {new Date().getFullYear()} |{" "}
                  {footer.copyright}
                </p>
                <span className="footer-contact">
                  {footer.helpText}{" "}
                  <a href={`mailto:${footer.email}`}>{footer.email}</a>
                </span>
              </div>
            </Col>
          </Row>
        </Container>

        {/* Back To Top  */}
        <BackToTop />
      </footer>
    </Styles>
  );
}

export default FooterTwo;
